import axios from 'axios'
const sha1 = require('js-sha1');

export default {
  getLatest: (rfc) => axios.post('/rfcs/opinion/latest',
    { rfc },
    { headers: { checksum: sha1(rfc || '') } }
  ),
  getPreview: (rfc, opinionId = null) => axios.post('/rfcs/opinion/preview',
    opinionId ? { rfc, opinion_id: opinionId } : { rfc },
    { headers: { checksum: sha1(rfc || '') }, skipLoading: true }
  ),
  generate: (rfc) => axios.post('/rfcs/opinion/generate',
    { rfc },
    { headers: { checksum: sha1(rfc || '') }, skipLoading: true }
  ),
  getDownloadLink: (rfc, opinionId = null) => axios.post('/rfcs/opinion/download',
    opinionId ? { rfc, opinion_id: opinionId } : { rfc },
    { headers: { checksum: sha1(rfc || '') }, skipLoading: true }
  ),
}
